import React, { type FC, useEffect } from 'react'
import { observer } from 'mobx-react-lite'
import classnames from 'classnames'
import { Switch, Typography, Tooltip } from 'shared/ui'
import { IS_CALLING_APP_LIGHT } from 'shared/config'
import { type IDeviceSettingsContentProps } from 'entities/DeviceSettings'
import { useEntitiesContext } from 'entities/EntitiesExport'
import styles from './styles.module.scss'

export const RecordAutoContent: FC<IDeviceSettingsContentProps> = observer(
  ({ deviceSettingsStore }) => {
    const { callStore, organizationStore } = useEntitiesContext()
    const disabled =
      callStore.isRecordLoading || organizationStore.isEnabledOrganisationCallAutoRecord
    const {} = deviceSettingsStore

    useEffect(() => {
      if (organizationStore.isEnabledOrganisationCallAutoRecord && !callStore.isRecord) {
        callStore.handleChangeRecord()
      }
    }, [])

    const ringEverywhereContent = () => {
      return (
        <div className={classnames(styles.dropdownWrap)}>
          <div className={styles.dropdownBox}>
            <Typography
              className={styles.label}
              variant={'body-md-regular'}
              ariaLabel={'Ring everywhere'}
            >
              Ring everywhere
            </Typography>
          </div>
          <div className={styles.dropdownBox}>
            <Switch
              className={styles.switch}
              value={callStore.isRingEverywhere}
              disabled={callStore.isRingEverywhereLoading}
              onChange={() => {
                callStore.handleChangeRingEverywhere()
              }}
            />
          </div>
        </div>
      )
    }

    const recordAutomaticallyContent = () => {
      return (
        <div
          className={classnames(styles.dropdownWrap, {
            [styles.disabled]: organizationStore.isEnabledOrganisationCallAutoRecord,
          })}
        >
          <div className={styles.dropdownBox}>
            <Typography
              className={styles.label}
              variant={'body-md-regular'}
              ariaLabel={'Record automatically'}
            >
              Record automatically
            </Typography>
          </div>
          <div className={styles.dropdownBox}>
            <Switch
              className={styles.switch}
              value={callStore.isRecord}
              disabled={disabled}
              onChange={() => {
                callStore.handleChangeRecord()
              }}
            />
          </div>
        </div>
      )
    }

    return (
      <div className={styles.section}>
        <div className={styles.dropdownContent}>
          {ringEverywhereContent()}
          {organizationStore.isEnabledOrganisationCallAutoRecord ? (
            <Tooltip
              fullWidth
              label='Call recording enabled globally'
              placement={IS_CALLING_APP_LIGHT ? 'bottom' : 'right'}
            >
              {recordAutomaticallyContent()}
            </Tooltip>
          ) : (
            recordAutomaticallyContent()
          )}
        </div>
      </div>
    )
  }
)
